import { RouteRecordRaw } from 'vue-router';

export const marketSizingRouteConfig: RouteRecordRaw = {
  name: 'marketSizing',
  path: '/market-sizing',
  component: () => import('@/components/market-sizing/layouts/main.vue'),
  meta: { accessScope: 'market_sizing' },
  redirect: { name: 'marketSizingNew' },
  children: [
    {
      path: '/market-sizing/new',
      component: () =>
        import('@/components/market-sizing/market-sizing-new.vue'),
      name: 'marketSizingNew',
      meta: { title: '市場規模を推定' },
    },
    {
      path: '/market-sizing/:uuid',
      component: () =>
        import('@/components/market-sizing/market-sizing-detail.vue'),
      name: 'marketSizingDetail',
      props: true,
      meta: { title: '市場規模推定の詳細' },
    },
  ],
};
